import React, { Component } from "react";

class DisccountWidget extends Component {
  render() {
    let { disccounts } = this.props;
    if (disccounts)
      return (
        <div id="disccounts-container">
          {disccounts.map(d => {
            return (
              <div key={d.id} className="card card-flex">
                <div className="row no-gutters">
                  <div className="col">
                    <img className="disccount-image" src={d.image} alt="" />
                  </div>
                  <div className="col">
                    <div className="card-block px-2">
                      <h4 className="card-title mt-1">{d.title}</h4>
                      <p className="card-text">{d.descripcion}</p>
                    </div>
                  </div>
                </div>
                <div className="card-footer w-100 text-muted">
                  <small className="text-muted">
                    {d.tiene_vigencia === "si"
                      ? `Vigente desde ${d.fecha_inicio} hasta ${
                          d.fecha_termino
                        }`
                      : `Vigencia: ${d.texto_vigencia}`}
                  </small>
                </div>
              </div>
            );
          })}
        </div>
      );
    else return <div />;
  }
}

export default DisccountWidget;



// WEBPACK FOOTER //
// ./src/views/DisccountWidget.js